import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function usePublicPortfolio() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    api.get("/portfolio").then((r) => setItems(r.data)).catch(() => { setError(true); setItems([]); });
  }, []);
  return { items, error };
}
